import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';

const MyProfile = ({ user, config, cmsSourceFirebase, actions, match }) => {
    const myProfileUrl = config?.config?.my_profile_host_uri ?? '';

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            {user.loggedIn ? null : <Redirect to='/login' />}
            <div className='my-5 text-center'>
                <h3>
                    Redirecting to My Profile page:
                    <a href={myProfileUrl}>{user.loggedIn && myProfileUrl ? window.location.replace(myProfileUrl) : null}</a>
                </h3>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);
